<template>
  <div>
    <div class="pane-header">
      <span
        v-if="props.icon"
        class="icon">
        <Component :is="props.icon" />
      </span>
      <span class="text">
        {{ props.name }}
      </span>

      <div class="custom-header">
        <slot name="header" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="pane-content">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    icon: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    name: string;
  }

  const props = defineProps<Props>();
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .pane-content {
    padding-top: 2rem !important;
  }

  .custom-header {
    margin-left: auto;
    display: flex;
  }
</style>
